import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { useLayout } from '../../core'
import { toAbsoluteUrl } from '../../../helpers'
import { AsideMenu } from './AsideMenu'
import { AsideUserMenu } from '../../../partials/layout/aside-menus/AsideUserMenu'

const AsideDefault = () => {
  const { classes } = useLayout()
  return (
    <div
      id='kt_aside'
      className={clsx('aside py-6', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_toggle'
    >
      {/* begin::Brand */}
      <div className='aside-logo flex-column-auto px-6 mb-5' id='kt_aside_logo'>
        {/* begin::Logo */}
        <Link to='/dashboard'>
          <img
            alt='Logo'
            className='h-40px logo theme-light-show mb-3 me-4'
            src={toAbsoluteUrl('/media/logos/favicon_partnerportal.png')}
          />
          <img
            alt='Logo'
            className='h-55px logo theme-light-show'
            src={toAbsoluteUrl('/media/logos/ofindo_logo_partnerportal.svg')}
          />
          <img
            alt='Logo'
            className='h-40px logo theme-dark-show mb-3 me-4'
            src={toAbsoluteUrl('/media/logos/favicon_partnerportal.png')}
          />
          <img
            alt='Logo'
            className='h-55px logo theme-dark-show'
            src={toAbsoluteUrl('/media/logos/ofindo_logo_partnerportal.svg')}
          />
        </Link>
        {/* end::Logo */}
      </div>
      {/* end::Brand */}

      {/* begin::Aside menu */}
      <div id='kt_aside_menu' className='aside-menu flex-column-fluid ps-6 pe-6 pe-lg-3'>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>
      {/* end::Aside menu */}

      {/* begin::Footer */}
      <div className='aside-footer flex-column-auto mx-3' id='kt_aside_footer'>
        <AsideUserMenu />
      </div>
      {/* end::Footer */}
    </div>
  )
}

export { AsideDefault }
